export const extensionImageComponent = 'image/png, .jpg, .jpeg';
export const extensionImageComponentList = ['png', 'jpg', 'jpeg', 'vnd.adobe.photoshop', 'gif', 'bmp'];
